import styled from 'styled-components';

export const CaseDateRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

export const CaseDate = styled.p`
  margin: 0;
  ${(props) => props.theme.newTypography.textStyleBodySmall}
`;

export const Error = styled.p`
  ${(props) => props.theme.newTypography.textStyleBodySmall};
  color: ${(props) => props.theme.newPalette.red.R300};
  margin: 0;
`;
